var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplaceDefault2222 = function SvgReplaceDefault2222(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949596",
    d: "M2 20H0v-6h6v2H3.52c1.61 2.41 4.36 4 7.48 4a9 9 0 0 0 9-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67zm-2-9C0 4.92 4.92 0 11 0c3.72 0 7.01 1.85 9 4.67V2h2v6h-6V6h2.48C16.87 3.59 14.12 2 11 2a9 9 0 0 0-9 9z"
  })));
};
export default SvgReplaceDefault2222;